/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
// eslint-disable-next-line no-underscore-dangle
(window as any).__Zone_disable_customElements = true;

// eslint-disable-next-line no-underscore-dangle
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['mousemove', 'pointermove'];
